module.exports = __webpack_public_path__ + "static/front/img/auth.959a740d.svg";